import { render } from "./transaction-pending-handler.vue?vue&type=template&id=211dba71&scoped=true"
import script from "./transaction-pending-handler.vue?vue&type=script&lang=js"
export * from "./transaction-pending-handler.vue?vue&type=script&lang=js"

import "./transaction-pending-handler.vue?vue&type=style&index=0&id=211dba71&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211dba71"]])

export default __exports__